<template>
    <div id="productoverlay">
        <div v-if="product.name" class="po__container" v-on-clickaway="close">
            <div class="po__close" @click="close">
                <span class="fa">&#xf00d;</span>
            </div>
            <div class="po__content">
                <div class="flex -wrap -space-between po__title">
                    <h3 v-html="product.name" class="text-ellipsis"></h3>
                    <div class="po__productprice" v-if="$store.getters['Auth/isAuthenticated']">
                        {{ product.price.sale_price | priceformat }}
                    </div>
                </div>
                <div class="product__subtitle primary-lighter">
                    <span v-if="product.climate_zone.naam" :title="$t('products.climate')">
                        <span class="fa">&#xf185;</span> {{ product.climate_zone.naam }}
                    </span>
                    <span v-if="product.form_description.naam" :title="$t('products.shape')">
                        {{ product.form_description.naam }}
                    </span>
                    <span v-if="product.shipping.products_per_level && product.shipping.levels_per_cc"
                        :title="$t('products.shipping_amount')">
                        <span class="fa">&#xf468;</span> {{ product.shipping.products_per_level }} &times; {{
                            product.shipping.levels_per_cc }}
                    </span>
                    <span v-if="product.remark" :title="$t('checkout.remarks')">
                        <span class="fa">&#xf27a;</span> {{ product.remark }}
                    </span>

                    <span v-if="$store.getters['Auth/isAuthenticated'] && product.available_units"
                        :title="$t('products.available_units')">
                        <span class="fa">&#xf466;</span> {{ product.available_units }}
                    </span>
                    <span>
                        {{ product.size.naam }} {{ product.pot_size.naam }}
                    </span>
                    <a v-if="product.manual" :href="product.manual" @click.stop :title="$t('products.manual')"
                        target="_blank">
                        <span class="fa">&#xf15c;</span> {{ $t('products.manual') }}
                    </a>
                </div>

                <div class="bg-info-light notice"
                    v-if="!$store.getters['Auth/isAuthenticated'] && webdata('algemeen.2.tekst', true)">
                    <div v-html="webdata('algemeen.2.tekst', true)"> </div>
                </div>

                <div class="po__images" v-if="images.length > 0">
                    <img class="po__image bg-contain -contain" :src="selectedImage" />
                    <ul class="po__thumbs">
                        <li v-for="(img, index) in images" :key="'productimg_' + index" class="bg-cover"
                            :class="{ 'is-selected': img === selectedImage }" @click="selectedImage = img">
                            <img :src="img" class="-stretch" />
                        </li>
                    </ul>
                </div>

                <div class="product__description" v-html="inlinedata(product.description[currentlang])"></div>
                <br />
            </div>
        </div>
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
    name: 'ProductInfo',
    props: {
        id: Number,
    },
    data() {
        return {
            product: {},
            selectedImage: null,
        };
    },
    computed: {
        currentlang() {
            return this.$store.getters['Language/current'];
        },

        images() {
            if (this.product.images) {
                if (this.product.images.large && this.product.images.large.length > 0) { return this.product.images.large; }
                if (this.product.images.preview) { return [this.product.images.preview]; }
            }
            return [];
        },
    },

    mounted() {
        this.init();
    },

    methods: {
        close() {
            this.$router.push({ name: 'products', params: { mode: this.$route.params.mode, scrollTo: false } });
        },

        updateImage() {
            if (this.images.length) {
                const [image] = this.images;
                this.selectedImage = image;
            }
        },

        init() {
            const data = this.$store.getters['Products/product'](this.id);
            if (data) {
                this.product = data;
                this.setMeta();
            } else {
                this.getItem();
            }
        },

        getItem() {
            this.loading = true;
            this.$store.dispatch('Products/get', { id: this.id })
                .then((r) => {
                    if (r && r[0]) {
                        // eslint-disable-next-line
                        this.product = r[0];
                        this.setMeta();
                    } else {
                        throw new Error('product not found');
                    }
                }).catch(() => {
                    this.$toast({ msg: this.$t('products.not_found'), classes: 'bg-danger' });
                    router.replace('/404');
                }).finally(() => {
                    this.loading = false;
                });
        },

        setMeta() {
            const data = {
                title: this.product.name,
                description: this.product.description.nl,
                image: this.product.images && this.product.images.preview,
            };
            this.$store.commit('setMeta', { data });
        },
    },
    directives: {
        onClickaway,
    },

    watch: {
        images: {
            handler: 'updateImage',
            immediate: true,
        },
    },
};
</script>

<style>
#productoverlay {
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    align-items: center;
    z-index: 50;
    justify-content: center;
}

.po__container {
    border: 0.1rem solid #d1d1d1;
    box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.05);
    background: #fff;
    border-radius: 0.4rem;
    position: relative;
    padding: 2.4rem;
    width: 96%;
    max-width: 60rem;
}

.po__title {
    align-items: center;
}

.po__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 2.4rem;
    color: var(--color-primary-lighter);
    cursor: pointer;
    transition: color .2s ease;
    z-index: 15;
}

.po__close:hover {
    color: var(--color-danger);
}

.po__productprice {
    background: var(--color-bg-darker);
    border-radius: 0.4rem;
    font-size: var(--size-4);
    display: inline-block;
    padding: 0.8rem 1.6rem;
}

.po__images {
    margin: 2rem -2.4rem;
}

.po__images ul.po__thumbs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.po__thumbs li {
    flex: 0 0 10rem;
    width: 10rem;
    height: 10rem;
    margin: 0rem;
    border: 0.4rem solid white;
    cursor: pointer;
}

.po__thumbs li.is-selected {
    border-color: var(--color-accent);
}

.po__image {
    background-color: var(--color-bg);
    width: 100%;
    height: 40rem;
    margin-bottom: 0.4rem;
}

.po__images li+li {
    margin-left: 0.4rem;
}
</style>
